import { trackEvent } from ".";
import {
  type AuthEventPayload,
  type OnboardingEventPayload,
  SegmentEvents,
  type SubscriptionEventPayload,
} from "./segmentEvents";

/**
 * Track an onboarding flow event
 */
export const trackOnboardingFlow = (
  payload: Partial<OnboardingEventPayload>,
) => {
  trackEvent(SegmentEvents.ONBOARDING, payload);
};

/**
 * Track an authentication flow event
 */
export const trackAuthFlow = (payload: Partial<AuthEventPayload>) => {
  trackEvent(SegmentEvents.AUTHENTICATION, payload);
};

/**
 * Track a subscription flow event
 */
export const trackSubscribeFlow = (
  payload: Partial<SubscriptionEventPayload>,
) => {
  trackEvent(SegmentEvents.SUBSCRIBE, payload);
};
